/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { shapes } from '@greenville/framework';
import PropTypes from 'prop-types';
import { Divider, List, ListItem } from '@material-ui/core';
import { ProfileDisplay } from '@greenville/mui-theme';
import { Box } from '@mui/material';
import CustomButton from '../../modules/aiadmin/common/components/CustomButton';
import UserProfileStyles from './UserProfileStyles';

const { root, header, divider, action, menuItem } = UserProfileStyles();
const UserProfile = ({ id, onLogoutRequest, language, user, ...rest }) => {
  return (
    <List id={id} {...rest}>
      <ListItem id={`${id}-profile`} sx={header}>
        <ProfileDisplay
          id={`${id}-profile-display`}
          name={user.fullName}
          email={user.email}
          avatarText={user.initials}
        />
      </ListItem>
      <Divider sx={divider} />
      <ListItem sx={action} disableGutters>
        <Box sx={menuItem}>
          <CustomButton
            label={<FormattedMessage {...language.getText('user.SIGNOUT')} />}
            onClick={onLogoutRequest}
            sx={root}
          />
        </Box>
      </ListItem>
    </List>
  );
};
UserProfile.defaultProps = {
  id: 'user-profile'
};

UserProfile.propTypes = {
  id: PropTypes.string,
  onLogoutRequest: PropTypes.func.isRequired,
  language: shapes.language.isRequired,
  user: shapes.user.isRequired
};

export default UserProfile;
